module.exports = __webpack_public_path__ + "static/bg3.fd2667dd.png";